import { Pipe, PipeTransform } from "@angular/core";
import { IMetaData } from "../interfaces";
import { LogClass, Logger } from "../logger";

@Pipe({
    name: "metadataSort",
    pure: true,
    standalone: false
})
@LogClass({ source: "MetadataSortPipe" })
export class MetadataSortPipe implements PipeTransform {
  private logger: Logger;

  public transform(value: IMetaData[]): IMetaData[] {
    if (!value) {
      return [];
    }

    const copy = [...value]; // copy first. Sort is in-place, this way we don't touch the original.
    copy.sort(this.sortMetadata);
    return copy;
  }

  public sortMetadata(x: IMetaData, y: IMetaData): number {
    const diff = (x.sort || 0) - (y.sort || 0);
    if (diff !== 0) {
      return diff;
    }

    // fallback: compare name
    return x.key.localeCompare(y.key);
  }
}
